package ru.villawonka.app.presentation.screens.favorites.compose

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import cafe.adriel.voyager.koin.koinScreenModel
import cafe.adriel.voyager.navigator.tab.LocalTabNavigator
import cafe.adriel.voyager.navigator.tab.Tab
import cafe.adriel.voyager.navigator.tab.TabOptions
import org.jetbrains.compose.resources.painterResource
import ru.villawonka.app.presentation.screens.favorites.viewmodel.FavoritesUIEvent
import ru.villawonka.app.presentation.screens.favorites.viewmodel.FavoritesUIState
import ru.villawonka.app.presentation.screens.favorites.viewmodel.FavoritesViewModel
import ru.villawonka.app.presentation.screens.search.compose.SearchScreen
import ru.villawonka.app.resources.AppResources
import villawonka.composeapp.generated.resources.Res
import villawonka.composeapp.generated.resources.ic_heart_24

object FavoritesScreen : Tab {

    override val options: TabOptions
        @Composable
        get() = TabOptions(
            index = 1u,
            title = AppResources.strings.bottomNavFavorites,
            icon = painterResource(Res.drawable.ic_heart_24)
        )

    @Composable
    override fun Content() {
        val tabNavigator = LocalTabNavigator.current
        val viewModel: FavoritesViewModel = koinScreenModel<FavoritesViewModel>()
        val state by viewModel.uiState.collectAsStateWithLifecycle(FavoritesUIState.Loading)

        LaunchedEffect(Unit) {
            viewModel.events.collect { event ->
                when (event) {
                    is FavoritesUIEvent.OpenSearch -> tabNavigator.current = SearchScreen
                }
            }
        }

        FavoritesRootLayout(
            state = state,
            callbacks = remember {
                FavoritesCallbacks(
                    onGoToSearchButtonClick = viewModel::onGoToSearchButtonClick,
                    onRetryButtonClick = viewModel::onRetryButtonClick,
                )
            }
        )
    }
}

data class FavoritesCallbacks(
    val onRetryButtonClick: () -> Unit,
    val onGoToSearchButtonClick: () -> Unit,
)